<div class="row">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header" style="background-color: #fff;">
                <h6>Daftar OPD</h6>
            </div>
            <div class="card-body">

                <form [formGroup]="formSearch" (submit)="refresh()">
                    <div class="row">
                        <!-- <div class="form-group col-2">
                            <small class="form-text text-muted">Kode / Nama</small>
                            <input type="text" class="form-control" id="kodeNama" name="kodeNama" formControlName="kodeNama" placeholder="Kode / Nama">
                        </div> -->
                        <div class="form-group col-2">
                            <small class="form-text text-muted">Nama SKPD</small>
                            <input type="text" class="form-control" id="kodeNama" name="kodeNama"
                                formControlName="kodeNama" placeholder="Kode / Nama">
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button type="submit" class="btn btn-secondary" style="margin-top: 21px;">
                                    <i class=" fa fa-search"></i> Cari
                                </button>
                            </div>
                        </div>
                    </div>

                </form>

                <hr>

                <div class="row">
                    <div class="col-12">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="row-border hover table table-bordered table-sm"></table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ngx-spinner></ngx-spinner>